const PlatformAdministrationContainerPage = () => import('@/pages/platform-administration/PlatformAdministrationContainerPage.vue')
const PlatformDashboardPage = () => import('@/pages/platform-administration/sub-pages/PlatformDashboardPage.vue')
const PlatformDonationTipConfigurationPage = () => import('@/pages/platform-administration/sub-pages/PlatformDonationTipConfigurationPage.vue')
const PlatformDonationTipVariantsPage = () => import('@/pages/platform-administration/sub-pages/PlatformDonationTipVariantsPage.vue')
const PlatformUsersPage = () => import('@/pages/platform-administration/sub-pages/PlatformUsersPage.vue')
const PlatformAppFeeRevenuePage = () => import('@/pages/platform-administration/sub-pages/PlatformAppFeeRevenuePage.vue')
const PlatformDatabaseDumpsPage = () => import('@/pages/platform-administration/sub-pages/PlatformDatabaseDumpsPage.vue')

export default [
  {
    path: "/platform",
    name: 'PlatformAdministrationContainerPage',
    component: PlatformAdministrationContainerPage,
    meta: { requiresAuth: true, requiresPlatformAdmin: true },
    children: [
      { path: '', name: 'PlatformDashboardPage', component: PlatformDashboardPage },
      { path: 'revenue', name: 'PlatformAppFeeRevenuePage', component: PlatformAppFeeRevenuePage },
      { path: 'users', name: 'PlatformUsersPage', component: PlatformUsersPage },
      { path: 'database-dumps', name: 'PlatformDatabaseDumpsPage', component: PlatformDatabaseDumpsPage },
      { path:'platform-donation-tip-configuration', name:'PlatformDonationTipConfigurationPage', component: PlatformDonationTipConfigurationPage },
      { path:'platform-donation-tip-variants', name:'PlatformDonationTipVariantsPage', component: PlatformDonationTipVariantsPage },
    ]
  }
]
